import type { ReactNode } from 'react';
import { Box, Flex } from '@qga/roo-ui/components';

import ErrorMessage from '@/components/ErrorMessage';

interface FormControlProps extends Omit<Flex.FlexProps, 'onClick'> {
  children: ReactNode;
  onClick: Function;
  disabled?: boolean;
  error?: string;
}

const FormControl = ({
  children,
  onClick,
  disabled,
  error,
  ...rest
}: FormControlProps) => {
  const handleClick = disabled ? () => {} : onClick;

  return (
    <Flex onClick={handleClick} {...rest}>
      {children}
      {error && (
        <Box>
          <ErrorMessage>{error}</ErrorMessage>
        </Box>
      )}
    </Flex>
  );
};

export default FormControl;
